export const getActiveVariantBy = <T>(
  { masterVariant, otherVariants }: { masterVariant?: T | null; otherVariants?: (T | null)[] },
  key: string,
  value: unknown
): T => {
  const xs = [masterVariant, ...(otherVariants || [])].filter(Boolean) as T[];
  return xs.find(x => x && x[key as keyof T] === value) || xs[0];
};
